var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V18C0 20.2091 1.79086 22 4 22H18C20.2091 22 22 20.2091 22 18V4C22 1.79086 20.2091 0 18 0H4ZM4.45996 2.46C3.35539 2.46 2.45996 3.35543 2.45996 4.46V17.79C2.45996 18.8946 3.35539 19.79 4.45996 19.79H17.79C18.8945 19.79 19.79 18.8946 19.79 17.79V4.46C19.79 3.35543 18.8945 2.46 17.79 2.46H4.45996Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3937 10.2437C9.83312 9.83812 9.33125 9.41875 9.33125 8.76562C9.33125 8.01625 10.0256 7.49375 11.1875 7.49375C12.1637 7.49375 12.6519 7.865 12.8306 8.45625C12.9131 8.73125 13.14 8.9375 13.4287 8.9375H13.635C14.0887 8.9375 14.4119 8.49062 14.2537 8.06437C13.965 7.25312 13.2912 6.57938 12.2187 6.31813V5.84375C12.2187 5.27313 11.7581 4.8125 11.1875 4.8125C10.6169 4.8125 10.1562 5.27313 10.1562 5.84375V6.2975C8.8225 6.58625 7.75 7.4525 7.75 8.77938C7.75 10.3675 9.06312 11.1581 10.9812 11.6187C12.7 12.0312 13.0437 12.6363 13.0437 13.2756C13.0437 13.75 12.7069 14.5063 11.1875 14.5063C10.0531 14.5063 9.46875 14.1006 9.24187 13.5231C9.13875 13.255 8.905 13.0625 8.62312 13.0625H8.43062C7.97 13.0625 7.64687 13.53 7.81875 13.9562C8.21062 14.9119 9.125 15.4756 10.1562 15.6956V16.1562C10.1562 16.7269 10.6169 17.1875 11.1875 17.1875C11.7581 17.1875 12.2187 16.7269 12.2187 16.1562V15.7094C13.5594 15.455 14.625 14.6781 14.625 13.2688C14.625 11.3163 12.9544 10.6494 11.3937 10.2437Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyNow);
export default __webpack_public_path__ + "static/media/buy-now.a4916880.svg";
export { ForwardRef as ReactComponent };